export const interviewBase = `
Your task is to create interview questions for a job interview in Markdown format. Add a header with the job title. Group the interview questions thematically into topics. The duration of interview should determine the depth and the quantity of the questions. The questions of the interviewer should be precise and clear. Avoid generic/standard questions (e.g. about salary expectation, strengths, weaknesses, ...). Make sure all interview questions can be asked and answered in the given duration of interview. Consider all inputs below. Do not include any input parameter in the output.
`;

export const cvAddidtion = `Ask questions about the Candidates CV in relation to the job requirements as well as questions on possible warning signs like gaps between jobs and unfitting previous jobs. Ask questions about previous jobs.
`;

export const responseExample = `
Example interview questions:

# Job ABC Interview questions

### Topic1

* Question1
* Question2

`;
